<style lang="less" scoped>
@import './index.less';
</style>
<template>
  <div>
    <organization v-on:selectLabId="selectLabId" v-on:storeCollegeId="storeCollegeId" :fixedTop=0></organization>
    <!-- <div class="addIcon" v-show="activeName=='record' && permissions.includes('weixinPerson_list_add')">
        <van-icon name="add-o" color="#07c160" size="40" @click='addRecord'/>
    </div> -->
    <div class="addBox" v-show="activeName == 'record' && permissions.includes('weixinPerson_list_add')"
      @click='addRecord'>
      新增
    </div>
    <div class="listTab">
      <van-tabs v-model="activeName" color='#00c1af' line-width='60px' sticky offset-top='0.1'
        title-inactive-color="#c8c9cc" title-active-color="#000">
        <van-tab title="操作记录" name="record" :title-class="{ fw: activeName == 'record' }">
          <!-- <template #title> <van-icon name="more-o" />选项 </template> -->
        </van-tab>
        <van-tab title="正在使用" name="using" :title-class="{ fw: activeName == 'using' }">
          <!-- <organization v-on:selectLabId="selectUsingLabId"></organization> -->

        </van-tab>
        <van-tab title="我的台账" name="mine" :title-class="{ fw: activeName == 'mine' }">
          <!-- <organization v-on:selectLabId="selectLedgerLabId" :fixedTop=96></organization> -->

        </van-tab>
      </van-tabs>
    </div>
    <div v-show="activeName == 'record'" style="margin-top: 102px;">
      <div class="weightFont" v-show="openLockNotHandleCount != 0">未处理：{{ openLockNotHandleCount }}</div>
      <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
        <div class="divMinHeight" v-show="operationData.length != 0">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getOperateList">
            <div class="recordDiv" v-for="item in operationData" :key="item.id">
              <van-cell-group inset>
                <van-cell>
                  <template #title>
                    <div class="cellTitle">
                      <span class="custom-title">{{ item.partition }}</span>
                      <div class="cellIcon">
                        <van-icon name="arrow" @click="lookLock(item.id, item.lockType)" />
                      </div>
                    </div>
                  </template>
                </van-cell>
                <van-cell>
                  <template #title>
                    <div class="recordProperty">
                      <span class="leftTitle">开门：</span>
                      {{ item.openTime }}
                    </div>
                    <!-- <div>
                                <span style="margin-right:27.2px;">关</span>门：
                                {{item.closeTime}}
                            </div> -->
                    <!-- <div>
                                <span style="letter-spacing: 6px;">课题</span>组：
                                {{item.labName}}
                            </div> -->
                    <!-- <div>
                                <span style="margin-right:27.2px;">区</span>域：
                                {{item.location}}
                            </div> -->
                    <div class="recordProperty">
                      <span class="leftTitle">位置：</span>
                      {{ item.position }}
                    </div>
                    <div class="recordProperty">
                      <span class="leftTitle">类型：</span>
                      <span style="margin-right:6px;" :class="{ fontW: item.lockType == 1 }">{{
      item.lockType == 0 ? '常规' : '应急' }}</span>
                    </div>
                    <div class="recordProperty">
                      <span class="leftTitle">状态：</span>
                      <span v-for="(s, index) in item.status" :key="index" style="margin-right:6px;">
                        <van-tag v-show="s == '未处理'" type="danger" size="large">未处理</van-tag>
                        <van-tag v-show="s == '领用'" plain type="primary" size="medium">领用</van-tag>
                        <van-tag v-show="s == '归还'" plain type="success" size="medium">归还</van-tag>
                        <van-tag v-show="s == '无操作'" plain type="warning" size="medium">无操作</van-tag>
                      </span>
                    </div>
                    <div class="recordProperty">
                      <span class="leftTitle">双人双锁：</span>{{ item.doubleLock == 0 ? '否' : '是' }}
                    </div>
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
          </van-list>
        </div>
        <div class="empty" v-show="operationData.length == 0">
          <van-empty description="暂无操作记录" image-size='160' />
        </div>
      </van-pull-refresh>
    </div>
    <div v-show="activeName == 'using'" style="margin-top: 102px;">
      <div class="usingList" v-show="already.length != 0">
        <div class="weightFont">正在使用：{{ already.length }}</div>
        <div class="usingDiv" v-for="item in already" :key="item.id">
          <van-row style="    display: flex;
    align-items: center;">
            <van-col span="16">
              <van-cell-group style="border-radius: 8px;">
                <van-cell style="border-radius: 8px;">
                  <template #title>
                    <div class="cellTitle">
                      <span class="custom-title">{{ item.itemName }}({{ item.size }}{{ item.unit }}{{
      item.purity == '' ? '' : `，${item.purity}` }}{{ item.level == '' ? '' :
      `，${item.level}` }})</span>
                      <!-- <div class="cellIcon" v-show="permissions.includes('weixinPerson_list_giveBack')">
                                <span style="color:#1989fa" @click="giveBack(item)">归还</span>
                                <span style="color:#1989fa">报废</span>
                            </div> -->
                    </div>
                    <div>
                      <span class="custom-title">{{ item.flagId }}</span>
                    </div>
                    <div>
                      <span class="custom-title">{{ item.mass }}</span>
                    </div>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-col>
            <van-col span="8" style="flex: 1;">
              <div class="cellIcon">
                <span style="color:#1989fa;margin-right: 10px;" @click="giveBack(item)">归还</span>
                <span style="color:#1989fa;margin-right: 10px;" @click="scrap(item)">报废</span>
                <span style="color:#1989fa" @click="clickRevocation(item)">撤销</span>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="empty" v-show="already.length == 0" style="margin-top: 160px;">
        <van-empty description="暂无数据，请添加领用" image-size='160' />
      </div>
    </div>
    <div v-show="activeName == 'mine'" style="margin-top: 48px;">
      <van-pull-refresh v-model="isLoading2" success-text="刷新成功" @refresh="onRefresh2">
        <div class="mineBox" v-show="searchData.length != 0">
          <van-list v-model="loading2" :finished="finished2" finished-text="没有更多了" @load="myLedger">
            <div class="mineDiv" v-for="(item, index) in searchData" :key="index">
              <van-cell-group inset>
                <van-cell>
                  <template #title>
                    <div class="cellTitle">
                      <div>
                        <span class="rIcon"></span>
                        <!-- <van-icon class-prefix="my-icon" name="huaxuepin" color="#42b983"/> -->
                        <span class="custom-title">{{ item.itemName }}</span>
                      </div>
                    </div>
                  </template>
                </van-cell>
                <van-cell>
                  <template #title>
                    <div class="property">
                      <span class='dosage'>用量：{{ item.usage }}</span>
                      <!-- <span class="time">余量：{{item.mass}}</span> -->
                    </div>
                    <div class="property">
                      <span class="dosage">余量：{{ item.mass }}</span>
                    </div>
                    <!-- <div class="property">
                                <span class='dosage'></span>
                                <span class="time">领：{{item.gbTime}}</span>
                            </div>
                            <div class="property">
                                <span class='dosage'></span>
                                <span class="time">还：{{item.time}}</span>
                            </div> -->
                  </template>
                </van-cell>
                <van-cell>
                  <template #title>
                    <div class="timeDiv">
                      <div class="rightTime">
                        <div class="time">
                          领：<span class="tiemWidth">{{ item.popTime }}</span>
                        </div>
                        <div class="time">
                          还：<span class="tiemWidth">{{ item.pushTime }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
          </van-list>
        </div>
        <div class="empty" style="margin-top:112px;" v-show="searchData.length == 0">
          <van-empty description="暂无台账" image-size='160' />
        </div>
      </van-pull-refresh>
    </div>
    <van-dialog v-model="show" :title=dialogTitle show-cancel-button @confirm='sureConfirm' @cancel='cancelGB'
      :before-close='beforeClose'>
      <div class="dialogDiv">
        <van-form label-width="60">
          <van-field v-model="dosage" name="用量" type="number" label="填写用量" :formatter="formatter" placeholder="请输入用量">
            <template slot='button'>
              <van-button type="info" size="small" style="width:42px;height: 26px;font-size: 14px;">{{
      unit }}</van-button>
            </template>
          </van-field>
          <van-field v-show="operationType == 1" readonly clickable :value="giveBackTime" label="归还时间"
            placeholder="点击选择时间" @click="clickGBT">
            <template slot="button">
              <van-button type="info" size="small" @click.stop='selectTime' style="height: 26px;">选择</van-button>
            </template>
          </van-field>
          <van-field v-show="operationType == 2" readonly clickable :value="reasonValue" label="报废原因"
            placeholder="点击选择原因" @click="selectReason">
            <template slot="button">
              <van-button type="info" size="small" @click.stop='selectReason' style="height: 26px;">选择</van-button>
            </template>
          </van-field>
          <van-field v-show="operationType == 2 && reasonValue == '其他'" :value="detailedReason" label="详细原因" rows="2"
            type="textarea" placeholder="报废原因为其他的话需要填写详细原因">
          </van-field>
        </van-form>
      </div>
    </van-dialog>
    <van-dialog v-model="addRecordDialog" title="填写操作记录" show-cancel-button @confirm='sureAdd' @cancel='cancelAdd'
      :before-close='beforeClose3'>
      <div class="dialogDiv">
        <van-form>
          <van-field readonly clickable name="picker" :value="recordCollege" label="学院" placeholder="点击选择学院"
            @click="showPicker4 = true" />
          <van-field readonly clickable name="picker" :value="recordLab" label="课题组" placeholder="请先选择学院再选择课题组"
            @click="showPicker5 = true" />
          <!-- <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="recordDevice"
                    label="操作设备"
                    placeholder="请先选择课题组再选择设备"
                    @click="showPicker3 = true"
                    /> -->
          <van-field readonly clickable name="picker" :value="recordArea" label="区域" placeholder="请先选择课题组再选择区域"
            @click="showPicker6 = true" />
          <van-field readonly clickable name="picker" :value="recordLocation" label="存储位置" placeholder="请先选择区域再选择存储位置"
            @click="showPicker7 = true" />
          <van-field readonly clickable name="picker" :value="recordPartition" label="分区" placeholder="请先选择存储位置再选择分区"
            @click="showPicker8 = true" />
          <van-field readonly clickable :value="recordOpenTime" label="开门时间" placeholder="点击选择开门时间" @click="clickROT" />
          <van-field readonly clickable :value="recordCloseTime" label="关门时间" placeholder="点击选择关门时间"
            @click="clickRCT" />
        </van-form>
      </div>
    </van-dialog>
    <van-popup v-model="showPicker1" round position="bottom">
      <van-picker show-toolbar title="选择时间(年月日时分秒)" :columns="columns1" @change='changeTime'
        @cancel='showPicker1 = false' @confirm='confirmTime' />
    </van-popup>
    <van-popup v-model="showPicker2" round position="bottom" :close-on-click-overlay='false'>
      <van-picker show-toolbar title="选择归还时间" :columns="columns2" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
    <van-popup v-model="showPicker3" position="bottom">
      <van-picker show-toolbar :columns="columns3" @confirm="onConfirm3" @cancel="showPicker3 = false" />
    </van-popup>
    <van-popup v-model="showPicker4" position="bottom">
      <van-picker show-toolbar title="选择学院" :columns="columns4" @confirm="onConfirm4" @cancel="showPicker4 = false" />
    </van-popup>
    <van-popup v-model="showPicker5" position="bottom">
      <van-picker show-toolbar title="选择课题组" :columns="columns5" @confirm="onConfirm5" @cancel="showPicker5 = false" />
    </van-popup>
    <van-popup v-model="showPicker6" position="bottom">
      <van-picker show-toolbar title="选择区域" :columns="columns6" @confirm="onConfirm6" @cancel="showPicker6 = false" />
    </van-popup>
    <van-popup v-model="showPicker7" position="bottom">
      <van-picker show-toolbar title="选择存储位置" :columns="columns7" @confirm="onConfirm7" @cancel="showPicker7 = false" />
    </van-popup>
    <van-popup v-model="showPicker8" position="bottom">
      <van-picker show-toolbar title="选择分区" :columns="columns8" @confirm="onConfirm8" @cancel="showPicker8 = false" />
    </van-popup>
    <van-action-sheet v-model="showActionSheet" :actions="actions" @select="onSelect" />
    <div class="searchDiv" v-show="activeName == 'mine'">
      <van-search v-model="keyword" show-action placeholder="请输入试剂名称" @search="onSearch">
        <template slot='action'>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Tab, Tabs, Cell, CellGroup, Panel, Icon, Tag, Dialog, Field, Notify, Popup, Picker, Search, Empty, Toast, PullRefresh, List, Button } from 'vant';
import { mapMutations, mapState } from 'vuex';
import { formatDate } from '@/libs/method';
import { getPermissions } from '../../assets/js/common'
import axios from "axios";
import organization from '../organizationAutoShowNum';
import Cookies from 'js-cookie';

export default {
  name: 'index',
  computed: {
    ...mapState(["openLockNotHandleCount"]),
  },

  components: {
    'organization': organization
  },
  data() {
    return {
      detailedReason: '',
      reasonValue: '',
      showActionSheet: false,
      actions: [{ name: '已经用尽' }, { name: '瓶身破碎' }, { name: '已过期' }, { name: '其他' }],
      scrapData: {
        tagId: '',
        remark: '',
        useMass: 0
      },
      // 1是归还，2是报废
      operationType: 1,
      dialogTitle: '填写用量和归还时间',
      isRefresh: false,
      permissions: [],
      ledgerLabId: 0,
      usingLabId: 0,
      labId: 0,
      unit: '',
      flagId: '',
      openLockLogId: '',
      surePass: false,
      sureAddPass: false,
      operationData: [],
      listPageIndex: 1,
      ledgerPageIndex: 1,
      loading: false,
      loading2: false,
      finished: false,
      finished2: false,
      activeName: 'record',
      show: false,
      dosage: 0,
      limitUsage: 0,
      giveBackTime: '',
      columns2: [],
      showPicker1: false,
      showPicker2: false,
      keyword: '',
      already: [],
      searchData: [],
      isLoading: false,
      isLoading2: false,
      columns1: [
        // 年
        {
          values: [],
          defaultIndex: 6,
        },
        // 月
        {
          values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          defaultIndex: 0,
        },
        // 日
        {
          values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
          defaultIndex: 0,
        },
        // 时
        {
          values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 23],
          defaultIndex: 0,
        },
        // 分
        {
          values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
          defaultIndex: 0,
        },
        // 秒
        {
          values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
          defaultIndex: 0,
        },
      ],
      year: 0,
      month: 0,
      day: 0,
      sms: '',
      useTimeList: [],
      operateLockLogId: 0,
      addRecordDialog: false,
      recordOpenTime: '',
      recordCloseTime: '',
      recordDevice: '',
      recordCollege: '',
      recordLab: '',
      recordArea: '',
      recordLocation: '',
      recordPartition: '',
      columns3: [],
      columns4: [],
      columns5: [],
      columns6: [],
      columns7: [],
      columns8: [],
      showPicker3: false,
      showPicker4: false,
      showPicker5: false,
      showPicker6: false,
      showPicker7: false,
      showPicker8: false,
      deviceList: [],
      areaList: [],
      locationList: [],
      partitionList: [],
      timeType: '',
      deviceId: '',
      collegeList: [],
      labList: [],
      formatter(value) {
        return value.replace(/-/g, '');
      },
      partitionId: ''
    };
  },

  created() {
    this.$store.state.tabShow = true;
    let permissions = JSON.parse(localStorage.permissions);
    console.log(permissions)
    this.permissions = getPermissions('weixinPerson_list', permissions);
    console.log(this.permissions)
    Vue.use(Tab);
    Vue.use(Tabs);
    Vue.use(Cell);
    Vue.use(CellGroup);
    Vue.use(Panel);
    Vue.use(Icon);
    Vue.use(Tag);
    Vue.use(Dialog);
    Vue.use(Field);
    Vue.use(Notify);
    Vue.use(Popup);
    Vue.use(Picker);
    Vue.use(Search);
    Vue.use(Empty);
    Vue.use(Toast);
    Vue.use(PullRefresh);
    Vue.use(List);
    Vue.use(Button);
    // this.getOperateList();
    // this.setPickTime();
    // this.getUsingList();
    // this.myLedger();
  },

  mounted() { },

  methods: {
    clickRevocation(item) {
      if (!this.permissions.includes('weixinPerson_list_popCancel')) {
        Notify({ type: 'warning', message: '无权限撤销', duration: 2000 });
        return false;
      }
      Dialog.confirm({
        title: '确认撤销该试剂的领用吗？',
        message: item.itemName,
      })
        .then(() => {
          this.revocation(item.flagId);
        })
        .catch(() => {
          // on cancel
        });
    },
    revocation(tagId) {
      let data = {tagId}
      let token = Cookies.get('token');
      axios({
        method: 'post',
        url: this.$store.state.context + '/Usage/PopCancel',
        data: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': token
        }
      }).then((res)=>{
        if (res.data.returnCode != 1) {
          Notify({ type: 'warning', message: res.data.message, duration: 2000 });
          return false;
        }
        Notify({ type: 'success', message: '撤销成功', duration: 2000 });
        this.getUsingList();
      })
    },
    selectReason() {
      this.showActionSheet = true;
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.showActionSheet = false;
      this.reasonValue = item.name;
    },
    onConfirm4(value, index) {
      this.recordCollege = value;
      this.recordLab = '';
      this.recordDevice = '';
      this.getLabList(this.collegeList[index].labId);
      this.showPicker4 = false;
    },
    onConfirm5(value, index) {
      this.recordLab = value;
      this.recordArea = '';
      this.recordLocation = '';
      this.recordPartition = '';
      this.getAreaByLabId(this.labList[index].labId);
      this.showPicker5 = false;
    },
    onConfirm6(value, index) {
      this.recordArea = value;
      this.recordLocation = '';
      this.recordPartition = '';
      this.getPositionById(this.areaList[index].labId, this.areaList[index].locationId);
      this.showPicker6 = false;
    },
    onConfirm7(value, index) {
      this.recordLocation = value;
      this.recordPartition = '';
      this.getPartition(this.locationList[index].positionId);
      this.showPicker7 = false;
    },
    onConfirm8(value, index) {
      this.recordPartition = value;
      this.partitionId = this.partitionList[index].partitionId;
      this.showPicker8 = false;
    },
    getCollegeList() {
      let data = {}
      this.$http.get(this.$store.state.context + '/Lab/GetCollegeList', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          this.collegeList = res.data.data;
          this.columns4 = [];
          for (let v of this.collegeList) {
            this.columns4.push(v.labName);
          }
        }
      })
    },
    getLabList(collegeLabId) {
      let data = {
        collegeLabId
      }
      this.$http.get(this.$store.state.context + '/Lab/GetLabList', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          this.labList = res.data.data;
          this.columns5 = [];
          for (let v of this.labList) {
            this.columns5.push(v.labName);
          }
        }
      })
    },
    storeCollegeId(collegeId) {
      this.$store.state.listCollegeId = collegeId;
    },
    selectLabId(labId) {
      if (!this.permissions.includes('weixinPerson_list_inquire')) {
        Notify({ type: 'warning', message: '无权限查询清单', duration: 2000 });
        return false;
      }
      this.$store.state.listLabId = labId;
      this.finished = false;
      this.finished2 = false;
      this.labId = labId;
      this.listPageIndex = 1;
      this.operationData = [];
      this.getOperateList();

      this.already = [];
      this.getUsingList();

      this.ledgerPageIndex = 1;
      this.searchData = [];
      this.myLedger();
      // if(this.activeName=='record'){
      //     this.listPageIndex=1;
      //     this.operationData=[];
      //     this.getOperateList();
      // }else if(this.activeName=='using'){
      //     this.already=[];
      //     this.getUsingList();
      // }else if(this.activeName=='mine'){
      //     this.ledgerPageIndex=1;
      //     this.searchData=[];
      //     this.myLedger();
      // }
    },
    clickROT() {
      this.setPickTime();
      this.timeType = 'recordOpenTime';
      this.showPicker1 = true;
    },
    clickRCT() {
      this.setPickTime();
      this.timeType = 'recordCloseTime';
      this.showPicker1 = true;
    },
    clickGBT() {
      this.setPickTime();
      this.timeType = 'giveBackTime';
      this.showPicker1 = true;
    },
    onConfirm3(value, index) {
      this.recordDevice = value;
      this.deviceId = this.deviceList[index].deviceId;
      this.showPicker3 = false;
    },
    addRecord() {
      this.addRecordDialog = true;
      this.getCollegeList();
    },
    getAreaByLabId(labId) {
      let data = {
        LabId: labId,
        pageIndex: 1,
        pageSize: 1000000
      }
      this.$http.get(this.$store.state.context + '/itemLocation/GetAreaByLabId', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          this.areaList = res.data.data;
          if (this.areaList.length == 0) {
            this.columns6 = ['无区域可选，请去添加区域']
          } else {
            this.columns6 = [];
            for (let v of res.data.data) {
              this.columns6.push(v.locationName);
            }
          }
        }
      })
    },
    getPositionById(labId, locationId) {
      let data = {
        LabId: labId,
        locationId: locationId,
        pageIndex: 1,
        pageSize: 10000
      }
      this.$http.get(this.$store.state.context + '/itemLocation/GetPositionById', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          this.locationList = res.data.data;
          if (this.locationList.length == 0) {
            this.columns7 = ['无位置可选，请去添加位置']
          } else {
            this.columns7 = [];
            for (let v of res.data.data) {
              this.columns7.push(v.positionName);
            }
          }
        }
      })
    },
    getPartition(positionId) {
      let data = {
        positionId,
        pageIndex: 1,
        pageSize: 1000
      }
      this.$http.get(this.$store.state.context + '/ItemLocation/GetPartition', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          this.partitionList = res.data.data;
          if (this.partitionList.length == 0) {
            this.columns8 = ['无分区可选，请去添加分区']
          } else {
            this.columns8 = [];
            for (let v of res.data.data) {
              this.columns8.push(v.partitionName);
            }
          }
        }
      })
    },
    cancelAdd() {
      this.recordArea = '';
      this.recordOpenTime = '';
      this.recordCloseTime = '';
      this.recordCollege = '';
      this.recordLab = '';
      this.recordLocation = '';
      this.recordPartition = '';
    },
    sureAdd() {
      if (!this.recordCollege) {
        Notify({ type: 'warning', message: '请选择学院', duration: 2000 });
        this.sureAddPass = false;
        return false;
      }
      if (!this.recordLab) {
        Notify({ type: 'warning', message: '请选择课题组', duration: 2000 });
        this.sureAddPass = false;
        return false;
      }
      if (!this.recordArea) {
        Notify({ type: 'warning', message: '请选择区域', duration: 2000 });
        this.sureAddPass = false;
        return false;
      }
      if (!this.recordLocation) {
        Notify({ type: 'warning', message: '请选择位置', duration: 2000 });
        this.sureAddPass = false;
        return false;
      }
      if (!this.recordPartition) {
        Notify({ type: 'warning', message: '请选择分区', duration: 2000 });
        this.sureAddPass = false;
        return false;
      }
      if (!this.recordOpenTime) {
        Notify({ type: 'warning', message: '请填写开门时间', duration: 2000 });
        this.sureAddPass = false;
        return false;
      }
      if (!this.recordCloseTime) {
        Notify({ type: 'warning', message: '请填写关门时间', duration: 2000 });
        this.sureAddPass = false;
        return false;
      }
      this.sureAddPass = true;
    },
    beforeClose3(action, done) {
      if (action == 'confirm') {
        if (this.sureAddPass) {
          let _this = this;
          let data = {
            partitionId: this.partitionId,
            openTime: this.recordOpenTime,
            closeTime: this.recordCloseTime,
          }
          let token = Cookies.get('token');
          axios({
            method: 'post',
            url: this.$store.state.context + '/Usage/AddOperate',
            data: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Authorization': token
            }
          }).then(function (res) {
            if (res.data.returnCode != 1) {
              Notify({ type: 'warning', message: res.data.message, duration: 2000 });
              done(false)
              return false;
            }
            Notify({ type: 'success', message: '添加成功', duration: 2000 });
            done()
            _this.cancelAdd();
            _this.listPageIndex = 1;
            _this.getOperateList();
          })
        } else {
          done(false)
        }
      } else {
        done()
      }
    },
    //设置打开的年月日是当前时间，并设置不可选择超过当天时间日期
    // setPickTime(){
    //     let months=[1,2,3,4,5,6,7,8,9,10,11,12];
    //     let days=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
    //     this.year=new Date().getFullYear();
    //     this.month=new Date().getMonth()+1;
    //     this.day=new Date().getDate();
    //     let yearArr=[];
    //     for(let i=0;i<6;i++){
    //         yearArr.unshift(this.year-i);
    //     }
    //     this.columns1[0].values=yearArr;
    //     this.columns1[1].values=months.splice(0,this.month);
    //     this.columns1[1].defaultIndex=this.month-1;
    //     this.columns1[2].values=days.splice(0,this.day);
    //     this.columns1[2].defaultIndex=this.day-1;
    // },
    // changeTime(e,arrVal,arrIndex){
    //     let months=[1,2,3,4,5,6,7,8,9,10,11,12];
    //     let days=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
    //     let selectYear=arrVal[0];
    //     let selectMonth=arrVal[1];
    //     if(this.year==selectYear){
    //         this.columns1[1].values=months.splice(0,this.month+1);
    //     }else{
    //         this.columns1[1].values=months;
    //         if(this.month==selectMonth){
    //             this.columns1[2].values=days.splice(0,this.day);
    //         }else{
    //             // this.columns1[2].values=days;
    //             let selectDays = new Date(selectYear,selectMonth,0).getDate();
    //             let daysArr=[];
    //             for(let i=1;i<=selectDays;i++){
    //                 daysArr.push(i);
    //             }
    //             this.columns1[2].values=daysArr;
    //         }
    //     }

    // },
    setPickTime() {
      let newData = new Date();
      let year = newData.getFullYear();
      let month = newData.getMonth();
      let day = newData.getDate();
      let hour = newData.getHours();
      let minute = newData.getMinutes();
      let second = newData.getSeconds();
      console.log(hour)
      console.log(minute)
      console.log(second)
      let yearArr = [];
      for (let i = 0; i < 6; i++) {
        yearArr.unshift(year - i);
      }
      this.columns1[0].values = yearArr;
      this.columns1[1].defaultIndex = month;
      this.columns1[2].defaultIndex = day - 1;
      this.columns1[3].defaultIndex = hour;
      this.columns1[4].defaultIndex = minute;
      this.columns1[5].defaultIndex = second;
    },
    changeTime(e, arrVal, arrIndex) {
      let selectYear = arrVal[0];
      let selectMonth = arrVal[1];
      let days = new Date(selectYear, selectMonth, 0).getDate();
      let daysArr = [];
      for (let i = 1; i <= days; i++) {
        daysArr.push(i);
      }
      this.columns1[2].values = daysArr;
    },
    confirmTime(arrVal, arrIndex) {
      let year = arrVal[0];
      let month = arrVal[1] < 10 ? `0` + arrVal[1] : arrVal[1];
      let day = arrVal[2] < 10 ? `0` + arrVal[2] : arrVal[2];
      let hour = arrVal[3] < 10 ? `0` + arrVal[3] : arrVal[3];
      let minute = arrVal[4] < 10 ? `0` + arrVal[4] : arrVal[4];
      let second = arrVal[5] < 10 ? `0` + arrVal[5] : arrVal[5];
      let time = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      this.operateLockLogId = 0;
      if (this.timeType == 'recordOpenTime') {
        this.recordOpenTime = time;
      } else if (this.timeType == 'recordCloseTime') {
        this.recordCloseTime = time;
      } else if (this.timeType == 'giveBackTime') {
        this.giveBackTime = time;
      }
      this.giveBackTime = time;
      this.showPicker1 = false;
    },
    selectTime() {
      this.getOperateListByUse();
    },
    getOperateListByUse() {
      let data = {
        openLockLogId: this.openLockLogId,
        flagId: this.flagId
      }
      this.$http.get(this.$store.state.context + '/Usage/GetOperateListByUse', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          this.useTimeList = res.data.data;
          if (this.useTimeList.length == 0) {
            // this.columns2=['无时间可选，请点击输入框手动选择']
            Notify({ type: 'warning', message: '无时间可选，请点击时间输入框手动选择', duration: 3000 });
          } else {
            this.columns2 = [];
            let deviceArr = [];
            for (let v of res.data.data) {
              if (!deviceArr.includes(v.partition)) {
                deviceArr.push(v.partition);
                this.columns2.push({
                  text: v.partition,
                  children: []
                })
              }
              // this.columns2.push(`${v.closeTime} / ${v.deviceName}`);
            }
            for (let v of res.data.data) {
              this.columns2[deviceArr.indexOf(v.partition)].children.push({
                text: v.closeTime,
              })
            }
            console.log(this.columns2)
            this.showPicker2 = true;
          }
        }
      })
    },
    ...mapMutations([
      // 'updateOperationData'
    ]),
    // changeTab(active){
    //     if(active=='using'){
    //         this.getUsingList();
    //     }else if(active=='mine'){
    //         this.myLedger();
    //     }
    // },
    myLedger() {
      if (this.isRefresh2) { return false; }
      let data = {
        labId: this.labId,
        keyword: this.keyword,
        pageIndex: this.ledgerPageIndex,
        pageSize: 10
      }
      this.$http.get(this.$store.state.context + '/Usage/MyLedger', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          if (this.ledgerPageIndex == 1) {
            this.searchData = res.data.data;
          } else {
            if (!this.finished2) {
              this.searchData = this.searchData.concat(res.data.data);
            }
          }
          this.loading2 = false;
          this.ledgerPageIndex = this.ledgerPageIndex + 1;
          if (this.searchData.length == res.data.totalCount) {
            this.finished2 = true;
          }
        }
        if (res.data.returnCode != 1) {
          Notify({ type: 'warning', message: res.data.message, duration: 2000 });
        }
      })
    },
    // selectUsingLabId(labId){
    //     this.usingLabId=labId;
    //     this.already=[];
    //     this.getUsingList();
    // },
    // selectLedgerLabId(labId){
    //     this.ledgerLabId=labId;
    //     this.ledgerPageIndex=1;
    //     this.searchData=[];
    //     this.myLedger();
    // },
    getUsingList() {
      let data = {
        labId: this.labId,
        keyword: '',
        pageIndex: 1,
        pageSize: 10000
      }
      this.$http.get(this.$store.state.context + '/Usage/GetUsingList', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          this.already = res.data.data;
        }
        if (res.data.returnCode != 1) {
          Notify({ type: 'warning', message: res.data.message, duration: 2000 });
        }
      })
    },
    onRefresh() {
      this.isRefresh = true;
      this.finished = false;
      this.listPageIndex = 1;
      let data = {
        labId: this.labId,
        userId: localStorage.HNLGpeopleUserId,
        pageIndex: 1,
        pageSize: 50,
        lockType: -1
      }
      this.$http.get(this.$store.state.context + '/Usage/GetOperateList', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          this.operationData = res.data.data;
          this.isLoading = false;
          if (this.operationData.length == res.data.totalCount) {
            this.finished = true;
          }
          this.isRefresh = false;
        }
        if (res.data.returnCode != 1) {
          this.isLoading = false;
          this.finished = true;
          Notify({ type: 'warning', message: res.data.message, duration: 2000 });
        }
      })
    },
    onRefresh2() {
      this.isRefresh2 = true;
      this.finished2 = false;
      this.ledgerPageIndex = 1;
      let data = {
        labId: this.ledgerLabId,
        keyword: this.keyword,
        pageIndex: this.ledgerPageIndex,
        pageSize: 10
      }
      this.$http.get(this.$store.state.context + '/Usage/MyLedger', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          this.searchData = res.data.data;
          this.isLoading2 = false;
          if (this.searchData.length == res.data.totalCount) {
            this.finished2 = true;
          }
          this.isRefresh2 = false;
        }
        if (res.data.returnCode != 1) {
          this.isLoading2 = false;
          this.finished2 = true;
          Notify({ type: 'warning', message: res.data.message, duration: 2000 });
        }
      })
    },
    getOperateList() {
      console.log(this.isRefresh)
      if (this.isRefresh) { return false; }
      if (this.listPageIndex == 1) {
        Toast.loading({
          message: '',
          forbidClick: true,
          duration: 0
        });
      }
      let data = {
        labId: this.labId,
        userId: localStorage.HNLGpeopleUserId,
        pageIndex: this.listPageIndex,
        pageSize: 100,
        lockType: -1
      }
      this.$http.get(this.$store.state.context + '/Usage/GetOperateList', { params: data }).then(res => {
        if (res.data.returnCode == 1) {
          if (this.listPageIndex == 1) {
            Toast.clear();
            this.operationData = res.data.data;
          } else {
            if (!this.finished) {
              this.operationData = this.operationData.concat(res.data.data);
            }
          }
          this.loading = false;
          this.listPageIndex = this.listPageIndex + 1;
          if (this.operationData.length == res.data.totalCount) {
            this.finished = true;
          }
          console.log(this.finished)
        }
        if (res.data.returnCode != 1) {
          this.loading = false;
          Toast.clear();
          Notify({ type: 'warning', message: res.data.message, duration: 2000 });
        }
      }).catch(err => {
        Toast.clear();
      });
    },
    onSearch() {
      this.ledgerPageIndex = 1;
      this.myLedger();
    },
    onCancel() {
      this.columns2 = [];
      this.showPicker2 = false;
    },
    onConfirm(value, index) {
      console.log(value)
      console.log(index)
      this.giveBackTime = value[1];
      this.showPicker2 = false;
      for (let v of this.useTimeList) {
        if (v.closeTime == this.giveBackTime) {
          this.operateLockLogId = v.lockLogId;
        }
      }
      this.columns2 = [];
    },
    lookLock(id, lockType) {
      this.$router.push({ name: 'operation', query: { id: id, lockType: lockType } })
    },
    cancelGB() {
      this.dosage = 0;
      this.giveBackTime = '';
      this.reasonValue = '';
      this.detailedReason = '';
    },
    beforeClose(action, done) {
      if (action == 'confirm') {
        if (this.surePass) {
          let _this = this;
          if (this.operationType == 1) {
            let data = {
              FlagId: this.flagId,
              LockLogId: this.openLockLogId,
              OperateLockLogId: this.operateLockLogId,
              PushDateTime: this.giveBackTime,
              Usage: this.dosage
            }
            let token = Cookies.get('token');
            axios({
              method: 'post',
              url: this.$store.state.context + '/Usage/PushItem',
              data: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': token
              }
            }).then(function (res) {
              if (res.data.returnCode != 1) {
                Notify({ type: 'warning', message: res.data.message, duration: 2000 });
                done(false)
                return false;
              }
              Notify({ type: 'success', message: '归还成功', duration: 2000 });
              done()
              _this.dosage = 0;
              _this.giveBackTime = '';
              _this.getUsingList();
              _this.listPageIndex = 1
              _this.getOperateList();
            })
          } else {
            let remark = this.reasonValue != '其他' ? this.reasonValue : this.detailedReason;
            let data = {
              tagId: this.scrapData.tagId,
              remark,
              useMass: this.dosage
            }
            let token = Cookies.get('token');
            axios({
              method: 'post',
              url: this.$store.state.context + '/Usage/ScrapReagent',
              data: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': token
              }
            }).then(function (res) {
              if (res.data.returnCode != 1) {
                Notify({ type: 'warning', message: res.data.message, duration: 2000 });
                done(false)
                return false;
              }
              Notify({ type: 'success', message: '报废成功', duration: 2000 });
              done()
              _this.dosage = 0;
              _this.reasonValue = '';
              _this.getUsingList();
              _this.listPageIndex = 1
              _this.getOperateList();
            })
          }

        } else {
          done(false)
        }
      } else {
        done()
      }
    },
    sureConfirm() {
      if (!this.dosage) {
        Notify({ type: 'warning', message: '请填写用量', duration: 2000 });
        this.surePass = false;
        return false;
      }
      if (this.dosage.charAt(this.dosage.length - 1) == '.') {
        Notify({ type: 'warning', message: '请填写正确数量', duration: 2000 });
        this.surePass = false;
        return false;
      }
      if (this.dosage.length >= 2 && this.dosage.charAt(0) == '0' && this.dosage.charAt(1) != '.') {
        Notify({ type: 'warning', message: '请填写正确数量', duration: 2000 });
        this.surePass = false;
        return false;
      }
      if (!/^\d+(?:\.\d{0,3})?$/.test(this.dosage)) {
        Notify({ type: 'warning', message: '请填写最多三位小数的正数', duration: 2000 });
        this.surePass = false;
        return false;
      }
      if (this.operationType == 1) {
        this.sureGB();
      } else {
        this.sureScrap();
      }
    },
    sureGB() {
      if (!this.giveBackTime) {
        Notify({ type: 'warning', message: '请填写时间', duration: 2000 });
        this.surePass = false;
        return false;
      }
      if (this.dosage < this.limitUsage) {
        Notify({ type: 'warning', message: `用量不能小于${this.limitUsage}`, duration: 2000 });
        return false;
      }
      this.surePass = true;
    },
    sureScrap() {
      if (!this.reasonValue) {
        Notify({ type: 'warning', message: '请选择报废原因', duration: 2000 });
        this.surePass = false;
        return false;
      }
      this.surePass = true;
    },
    scrap(item) {
      if (!this.permissions.includes("weixinPerson_scrap_reagent")) {
        Notify({ type: 'warning', message: '无权限操作', duration: 2000 });
        return false;
      }
      this.operationType = 2;
      this.show = true;
      this.dialogTitle = '填写用量和报废原因';
      this.unit = item.unit;
      this.scrapData.tagId = item.flagId;
    },
    giveBack(item) {
      if (!this.permissions.includes('weixinPerson_list_giveBack')) {
        Notify({ type: 'warning', message: '无权限操作', duration: 2000 });
        return false;
      }
      this.operationType = 1;
      this.show = true;
      this.dialogTitle = '填写用量和归还时间';
      this.openLockLogId = item.lockLogId;
      this.flagId = item.flagId;
      this.unit = item.unit;
      this.GBid = item.itemId;
      this.dosage = item.useMass;
      this.limitUsage = item.useMass;
    },
  },

  watch: {
    keyword(newVal) {
      if (newVal == '') {
        this.ledgerPageIndex = 1;
        this.myLedger();
      }
    },
    activeName(newVal) {
      if (this.activeName == 'record') {
        this.listPageIndex=1;
        this.getOperateList();
      } else if (this.activeName == 'using') {
        this.getUsingList();
      } else if (this.activeName == 'mine') {
        this.myLedger();
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/index/index.vue?2795e43f